import { useEffect, useRef, useState } from "react";
import { columns, metaData } from "../static-models/MemberReceiptTab";
import { useAppSelector } from "../redux/hooks";
import formatDate from "../util/dateFormat";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import useButtonStyles from "../styles/useButtonStyles";
import theme from "../theme";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import UpdateMemberReceipts from "../components/member/UpdateMemberReceipts";
import { operatorConstants } from "../util/SearchandFIlters/Constants";
import { getHashURL } from "../util/SearchandFIlters/searchAndFilter";
import { useNavigate, useParams } from "react-router";
import { getEncodedValue } from "../components/forms/utility";
import InfiniteTable from "../components/Table/InfiniteScroll/InfiniteTable";
import { getReceipts } from "../services/ApiServices/Receipts";
import {
  SearchToolTip,
  filterConstants,
  DateConstants,
} from "../constants/AppConstants";
import SearchInput from "../Shared/Components/SearchInput/SearchInput";
import InputProps from "./SharedContents/InputProps";

export interface MemberReceiptTabTableData {
  id?: string;
  image: string;
  amount: number;
  calculated_receipt_amount: number;
  merchant: string;
  merchant_type: string;
  receipt_number: string;
  submission_date: string;
  status: string;
  review_date: string;
  points_awarded: number;
  birthday_points: number;
}
const dropdownOptions = [
  { id: filterConstants.Accept.toLowerCase(), label: filterConstants.Accept },
  { id: filterConstants.Reject.toLowerCase(), label: filterConstants.Reject },
  {
    id: filterConstants.Pending.toLowerCase(),
    label: filterConstants.Pending,
  },
  {
    id: filterConstants.Processing.toLowerCase(),
    label: filterConstants.Processing,
  },
  {
    id: filterConstants.Appeal.toLowerCase(),
    label: filterConstants.Appeal,
  },
];
const MemberReceiptTab = () => {
  const entityConstants = {
    amount_from: "amount_from",
    amount_to: "ammount_to",
    adjust_from: "adjusted_from",
    adjust_to: "adjust_to",
  };
  const params = useParams();
  const buttonStyles = useButtonStyles();
  const navigate = useNavigate();
  const [openFilter, setOpenFilter] = useState(false);
  const [memberReceiptData, setMemberReceiptData] = useState<
    MemberReceiptTabTableData[] | []
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isInitalApiCall, setInitialApiCall] = useState<boolean>(true);

  const [filterActive, setFilterActive] = useState(false);
  const [nextPageKey, setNextPageKey] = useState(null);
  const [apiFromKey, setApiFromKey] = useState<Number>(0);
  const [totalDataCount, setTotalDataCount] = useState<Number>(0);
  const [updatedDateFilter, setupdatedDateFilter] = useState({});
  const [updatedAdjustedAmount, setupdatedAdjustedAmount] = useState({});
  const [selectedOption, setSelectedOption] = useState("");
  const [updatedAmntInput, setUpdatedAmntInput] = useState({});
  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList,
  );

  const fetchMemberReceipts = async (
    urlString?: string,
    mergeData?: boolean,
  ) => {
    setLoading(true);
    let currentURl = `fromKey=${apiFromKey}`;
    if (urlString) currentURl += `&${urlString}`;
    try {
      if (nextPageKey) {
        currentURl += `&lastKey=${encodeURIComponent(
          JSON.stringify(nextPageKey),
        )}`;
      }
      currentURl += "&module=members&feature=receipts";

      const response = await getReceipts(currentURl);
      const { lastKey, result, fromKey, totalCount } = response;
      setNextPageKey(lastKey ? lastKey : null);
      setApiFromKey(fromKey);
      setTotalDataCount(totalCount);
      const receiptData: any = result?.map((data: any) => {
        const receipt = data?._source;
        return {
          image: receipt.upload_log[0].receipt_image,
          receipt_number: receipt.receipt_number,
          receipt_date:
            receipt.date_of_purchase !== 0
              ? formatDate(receipt.date_of_purchase)
              : "-",

          amount: receipt.amount_member
            ? receipt.amount_member
            : receipt.amount_member === 0
              ? 0
              : "-",
          calculated_receipt_amount: receipt.amount_bpo,
          submission_date: formatDate(receipt.submission_date),
          review_date:
            receipt.reviewed_date !== 0
              ? formatDate(receipt.reviewed_date)
              : "-",
          merchant: receipt.merchant_name !== "" ? receipt.merchant_name : "-",
          subcategory: receipt.subcategory ? receipt.subcategory : "_",
          points_awarded: receipt.points,
          bonus_point: receipt.bonus_points ? receipt.bonus_points : "-",
          status: receipt.receipt_status,
          // navigateTo: receipt.id ? window.location.pathname.replace("/admin", "")+"/"+receipt.id : "-",
          navigateTo: receipt.id
            ? `/viewMember/${receipt.id}` //   ${receipt.member}/${receipt.id}`
            : "-",
          yuuAmount: receipt?.yuu_included_amount
            ? receipt?.yuu_included_amount
            : receipt?.yuu_included_amount === 0
              ? 0
              : "-",
        };
      });

      const dataToMerge = mergeData
        ? [...memberReceiptData, ...receiptData]
        : receiptData;
      setMemberReceiptData(dataToMerge);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
      setInitialApiCall(false);
    }
  };

  const resetFilterState = () => {
    setUpdatedAmntInput({});
    setupdatedDateFilter({});
    setupdatedAdjustedAmount({});
    setSelectedOption("");
    onReset();
    setInitialApiCall(true);
    setFilterActive(false);
  };

  const [openDrawer, setOpenDrawer] = useState(false);
  const applyReceiptsFilter = () => {
    const filters = getFilterValues();
    setOpenFilter(false);
    onReset();
    setInitialApiCall(true);
    filters.length && setFilterActive(true);
  };
  // search integration
  const handleSearch = () => {
    setOpenFilter(false);
    onReset();
    setInitialApiCall(true);
  };

  const onReset = () => {
    setMemberReceiptData([]);
    setNextPageKey(null);
    setApiFromKey(0);
    setTotalDataCount(0);
  };

  useEffect(() => {
    if (params?.receiptsId) setOpenDrawer(true);
    else setOpenDrawer(false);
  }, [params]);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    navigate(`/viewMember`); // /${params?.memberId}`);
  };
  useEffect(() => {
    if (isInitalApiCall) bindSearchAndFilter();
  }, [isInitalApiCall]);

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };
  const onInputAmntChange = (filedName: string, value: any) => {
    setUpdatedAmntInput((prev) => ({
      ...prev,
      [filedName]: value,
    }));
  };
  const onInputAdjustedAmntChange = (filedName: string, value: any) => {
    setupdatedAdjustedAmount((prev) => ({
      ...prev,
      [filedName]: value,
    }));
  };
  const onInputChange = (filedName: string, value: any, states: any) => {
    states((prevState: any) => ({
      ...prevState,
      [filedName]: value,
    }));
  };

  const getInputValue = (fieldItem: any, state: any) => {
    const item = state[fieldItem as keyof typeof state];
    return item !== undefined ? item : "";
  };
  const getAmntInputValue = (fieldName: any) => {
    const item = updatedAmntInput[fieldName as keyof typeof updatedAmntInput];
    return item !== undefined ? item : "";
  };
  const getAdjustedAmntInputValue = (fieldName: any) => {
    const item =
      updatedAdjustedAmount[fieldName as keyof typeof updatedAdjustedAmount];
    return item !== undefined ? item : "";
  };

  const getFilterDates = () => {
    const data = Object.keys(updatedDateFilter).map((item: any) => {
      return updatedDateFilter[item as keyof typeof updatedDateFilter]
        ? {
            fieldValue: item,
            value: updatedDateFilter[item as keyof typeof updatedDateFilter]
              ? new Date(
                  updatedDateFilter[item as keyof typeof updatedDateFilter],
                )
                  .getTime()
                  .toString()
              : "",
            operator: operatorConstants.equal,
          }
        : {};
    });

    return data;
  };
  const getFilterStatus = () => {
    const statusParam = [];
    if (selectedOption !== "")
      statusParam.push({
        fieldValue: "receipt_status",
        value: selectedOption,
        operator: operatorConstants.equal,
      });
    return statusParam;
  };
  const getFilterAmount = () => {
    const amntData = Object.keys(updatedAmntInput)
      .filter(
        (key) =>
          key && updatedAmntInput[key as keyof typeof updatedAmntInput] !== "",
      )
      .map((key) => updatedAmntInput[key as keyof typeof updatedAmntInput]);

    const adjustedSAmnt = Object.keys(updatedAdjustedAmount)
      .filter(
        (key) =>
          key &&
          updatedAdjustedAmount[key as keyof typeof updatedAdjustedAmount] !==
            "",
      )
      .map(
        (key) =>
          updatedAdjustedAmount[key as keyof typeof updatedAdjustedAmount],
      );

    const filterValue = {
      fieldValue: "amount_member",
      value: amntData,
      operator: operatorConstants.between,
    };
    const adjustedValue = {
      fieldValue: "amount_bpo",
      value: adjustedSAmnt,
      operator: operatorConstants.between,
    };
    const amnt_val = [];
    if (amntData.length > 1) {
      amnt_val.push(filterValue);
    }
    if (adjustedSAmnt.length > 1) {
      amnt_val.push(adjustedValue);
    }
    return amnt_val;
  };
  const getFilterValues = () => {
    const filterDateParam = getFilterDates();
    const filterStatus = getFilterStatus();
    const filterAmount = getFilterAmount();

    const filterParam = [...filterDateParam, ...filterAmount, ...filterStatus];
    return filterParam;
  };
  const handleOnCloseFilter = () => {
    setOpenFilter(false);
  };
  // bind function
  const searchInputRef = useRef<HTMLInputElement>();

  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    const filters = getFilterValues();
    const hashValue = {
      field: "memberId",
      value: memberDetails.email,
    };
    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const params = {
      hashData: hashValue,
      searchData: searchParam,
      filterData: filters,
    };
    const url = getHashURL(params);
    fetchMemberReceipts(url, canHaveExistingData);
    return url;
  };
  return (
    <>
      <Grid display={"flex"} justifyContent={"center"} px={4} py={3}>
        <Dialog
          onClose={handleCloseFilter}
          open={openFilter}
          sx={{ ml: "60vw" }}
        >
          <Grid sx={{ width: "484px", py: 4, px: 2 }}>
            <DialogTitle
              display={"flex"}
              justifyContent={"space-between"}
              borderBottom={theme.border?.smallGrey}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.primary,
                  fontSize: theme.font?.fontSize.large,
                  fontWeight: theme.font?.fontWeight.thicker,
                }}
              >
                Filter
              </Typography>
              <IconButton onClick={handleOnCloseFilter}>
                <CloseOutlinedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
              <Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Receipt Date
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "180%",
                      }}
                      type="date"
                      size="small"
                      placeholder="Transaction Date"
                      value={getInputValue(
                        "date_of_purchase",
                        updatedDateFilter,
                      )}
                      onChange={(e) => {
                        onInputChange(
                          "date_of_purchase",
                          e.target.value,
                          setupdatedDateFilter,
                        );
                      }}
                      InputProps={{
                        inputProps: {
                          max: DateConstants.maxDate,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Submitted Date
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "180%",
                      }}
                      type="date"
                      size="small"
                      placeholder="Transaction Date"
                      value={getInputValue("createdAt", updatedDateFilter)}
                      onChange={(e) => {
                        onInputChange(
                          "createdAt",
                          e.target.value,
                          setupdatedDateFilter,
                        );
                      }}
                      InputProps={{
                        inputProps: {
                          max: DateConstants.maxDate,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Reviewed Date
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "180%",
                      }}
                      type="date"
                      size="small"
                      placeholder="Transaction Date"
                      value={getInputValue("reviewed_date", updatedDateFilter)}
                      onChange={(e) => {
                        onInputChange(
                          "reviewed_date",
                          e.target.value,
                          setupdatedDateFilter,
                        );
                      }}
                      InputProps={{
                        inputProps: {
                          max: DateConstants.maxDate,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Amount ($)
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "50%",
                      }}
                      type="text"
                      size="small"
                      label="From"
                      value={getAmntInputValue(entityConstants.amount_from)}
                      onChange={(e) =>
                        onInputAmntChange(
                          entityConstants.amount_from,
                          e.target.value,
                        )
                      }
                      // value={inputCompRef.current.amnt_from?.value}
                      // inputRef={(ref)=> (inputCompRef.current.amnt_from= ref)}
                    />
                    <TextField
                      sx={{
                        display: "flex",
                        width: "50%",
                      }}
                      type="text"
                      size="small"
                      label="To"
                      value={getAmntInputValue(entityConstants.amount_to)}
                      onChange={(e) =>
                        onInputAmntChange(
                          entityConstants.amount_to,
                          e.target.value,
                        )
                      }
                    />
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Adjusted Amount ($)
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "50%",
                      }}
                      type="text"
                      size="small"
                      label="From"
                      value={getAdjustedAmntInputValue(
                        entityConstants.adjust_from,
                      )}
                      onChange={(e) =>
                        onInputAdjustedAmntChange(
                          entityConstants.adjust_from,
                          e.target.value,
                        )
                      }
                    />
                    <TextField
                      sx={{
                        display: "flex",
                        width: "50%",
                      }}
                      type="text"
                      size="small"
                      label="To"
                      value={getAdjustedAmntInputValue(
                        entityConstants.adjust_to,
                      )}
                      onChange={(e) =>
                        onInputAdjustedAmntChange(
                          entityConstants.adjust_to,
                          e.target.value,
                        )
                      }
                    />
                  </Grid>
                </Grid>
                <InputProps
                  label="Status"
                  value={selectedOption}
                  type="Select"
                  inputPlaceHolder="From"
                  onInputChange={(data) => {
                    setSelectedOption(data.target.value);
                  }}
                  options={dropdownOptions}
                />
              </Grid>
            </DialogContent>
            <DialogActions sx={{ pr: 4, gap: 1, pt: 2 }}>
              <Button
                sx={{ ...buttonStyles.outlinedSecondary }}
                onClick={resetFilterState}
              >
                Reset
              </Button>
              <Button
                sx={{ ...buttonStyles.containedSecondary }}
                onClick={applyReceiptsFilter}
              >
                Apply
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
        <Grid display={"flex"} gap={3} width={"100%"} justifyContent={"end"}>
          <SearchInput
            HelpTip={SearchToolTip.MemberReceipts}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
          <Button
            variant="text"
            startIcon={
              filterActive ? (
                <FilterAltIcon sx={{ color: theme.color?.secondary }} />
              ) : (
                <FilterAltOutlinedIcon />
              )
            }
            sx={{ color: theme.color?.newFilterGrey }}
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            Filter
          </Button>
        </Grid>
      </Grid>
      <Drawer
        anchor={"right"}
        open={Boolean(openDrawer)}
        onClose={handleCloseDrawer}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px 0 0 16px",
          },
        }}
      >
        <Grid width={"920px"} height={"100%"}>
          <UpdateMemberReceipts
            // receipt={openReceipt?.id}
            onRefresh={() => {
              onReset();
              setInitialApiCall(true);
            }}
            closeDrawer={handleCloseDrawer}
            module="members"
          />
        </Grid>
      </Drawer>
      <InfiniteTable
        header={columns}
        contentItems={memberReceiptData}
        hasMoreRecords={nextPageKey !== null}
        fetchMoreData={() => bindSearchAndFilter(true)}
        isInitialLoading={isInitalApiCall}
        metaData={metaData}
        totalRecords={totalDataCount}
      />
    </>
  );
};

export default MemberReceiptTab;
